import { Events } from '../events';
import type { SignalEvent } from '../types';
import { useEmitter, useListener } from '../utils';

type Value = string;

export function useBasketAddEmitter() {
    return useEmitter<Value>(Events.BasketAdd);
}

export function useBasketAddListener(onSignal: SignalEvent<Value>) {
    return useListener<Value>({
        eventName: Events.BasketAdd,
        onSignal,
    });
}
